import { createGlobalStyle, css } from 'styled-components';
import { objectEntries } from 'modules/utils/objectEntries';
/**
 * Create all CSS variables for the theme, based on the theme object's keys & values
 * prefix with "t-" to avoid conflicts with other third-party CSS variables
 * @example
 * createCSSVariables({ fontSize: { small: '1rem', large: '2rem' } }
 * // Resulting CSS:
 * --t-fontSize-small: 1rem;
 * --t-fontSize-large: 2rem;
 */
const createCSSVariables = (tokens, prefix = '--t') => objectEntries(tokens)
    .flatMap(([key, value]) => {
    if (typeof value === 'object' && value !== null) {
        return createCSSVariables(value, `${prefix}-${key}`);
    }
    return `${prefix}-${key}: ${value};`;
})
    .join('');
const styles = css `
  :root {
    ${(props) => createCSSVariables(props.theme)};
  }
`;
export const ThemeVariables = createGlobalStyle `${styles}`;
